import React, { ErrorInfo, useEffect } from 'react';
import { Error, useResetErrorBoundaryOnLocationChange } from 'react-admin';
import * as Sentry from '@sentry/react';

const SentryError = ({
  error,
  errorInfo,
  resetErrorBoundary,
}: {
  error: Error;
  errorInfo?: ErrorInfo;
  resetErrorBoundary: (...args: any[]) => void;
}) => {
  useResetErrorBoundaryOnLocationChange(resetErrorBoundary);

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return <Error error={error} errorInfo={errorInfo} resetErrorBoundary={resetErrorBoundary} />;
};

export default SentryError;
